import { FC } from 'react';
import { ESize } from 'src/styles/theme/utils/enums';
import { StyledNGSkeleton } from './NGSkeleton.styles';
import { INGSkeleton } from './NGSkeleton.type';

const NGSkeleton: FC<INGSkeleton> = ({
	width = 60,
	height = ESize.s,
	isCircle = false,
	transparentBackground,
	withBorder,
	...otherProps
}) => {
	return (
		<StyledNGSkeleton
			width={width}
			height={height}
			isCircle={isCircle}
			transparentBackground={transparentBackground}
			withBorder={withBorder}
			{...otherProps}
		/>
	);
};

export { NGSkeleton };
